interface PermissionRole {
  [key: string]: Array<string>;
}

interface PageName {
  [key: string]: string;
}

/**
 * Since every page is accessed only if the user owns certain roles,
 * we must define a set of Pages and the roles of every page
 */

export const PAGE_NAMES: PageName = {
  PMO: 'PMO',
  ADMIN: 'ADMIN',
};

const PERMISSION_ROLES: PermissionRole = {
  PMO: ['PMO'],
  ADMIN: ['ADMIN'],
};

export enum Role {
  SUPER = 'SUPER',
  ADMIN = 'ADMIN',
  PMO = 'PMO',
}

export default PERMISSION_ROLES;
